import {FETCH_PAYMENT_SUCCESS} from "../actions/PaymentActions";

const initialState = {
    payments: [],
    defaultPaymentMethod: '1',
};

export default function PaymentReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_PAYMENT_SUCCESS:
            return {
                ...state,
                ...action.payload,
                defaultPaymentMethod: action.payload.payments ? action.payload.payments[0]['pay_system_type'] : '1',
            };
    }

    return state;
}